import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import { useLazyGetHiresCompaniesQuery } from '../../../../services/hiresV2';
import { FormikAutoSubmit } from '../../../../components/atoms/formikAutoSubmit';

export const HiresCompanyFilter = ({ companyName, setFilters }) => {
  const [getHiresCompanies] = useLazyGetHiresCompaniesQuery();

  const onSearchChange = (currentValue) =>
    getHiresCompanies({ query: currentValue || '' })
      .unwrap()
      .then((res) => res)
      .catch(() => []);

  const onSubmit = ({ companyName: companies }) => {
    setFilters({ companyName: companies || [] });
  };

  return (
    <Formik initialValues={{ companyName: companyName || [] }} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="companyName"
          placeholder="Search"
          size="small"
          component={FormAsyncMultiSelect}
          loadOptions={onSearchChange}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

HiresCompanyFilter.propTypes = {
  companyName: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

HiresCompanyFilter.defaultProps = {
  companyName: [],
};
